import AdminDashboard from "@/pages/AdminDashboard";

// Thin wrapper that reuses AdminDashboard with practitioner styling.
// Backend access control (practitioner_scope) already enforces what data this user sees.
export default function PractitionerDashboard() {
  return <AdminDashboard mode="practitioner" />;
}
